import {Component, EventEmitter, Injector, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Company, User, UserTab} from '../../../../auth/models';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ToastService} from "../../../../main/services";
import {ActivatedRoute, Router} from "@angular/router";
import {TenderImportModalComponent} from "../../../components";

@Component({
    selector: 'jft-tender-search-bar',
    templateUrl: './tender-search-bar.component.html',
    styleUrls: ['./tender-search-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenderSearchBarComponent implements OnInit {

    public term: string;
    @Input()
    public company: Company;

    @Output()
    private onChanges = new EventEmitter();

    constructor(
        public user: User,
        private ngbModal: NgbModal,
        private injector: Injector,
        private toast: ToastService,
        private router: Router,
        private route: ActivatedRoute,
    ) {
    }

    public ngOnInit() {
    }

    public search() {
        this.onChanges.next(this.term);
    }

    public clearTerm() {
        delete this.term;
        this.onChanges.next(this.term);
    }

    public openImportXlsModalContacts() {
        this.ngbModal.open(TenderImportModalComponent, {
            injector: Injector.create([
                // {
                //     provide: Tender,
                //     //useValue: this.tender
                // },
            ], this.injector),
            size: 'lg',
            backdrop: 'static'
        }).result.then((item) => {
            this.toast.success(item);
        }, (error) => {
            if (error !== 'close'){
                //this.openInfoModal(error ? error.error.details: '')
            }
        });
    }
}
